import _RentalTripApprovalService from "../services/rental-trip-approval-service";
import { IRentalTripApprovalService } from "../types/services/rental-trip-approval-service";

const RentalTripApprovalService: IRentalTripApprovalService = new _RentalTripApprovalService();

export default RentalTripApprovalService;
